import script from "./FooterBars.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterBars.vue?vue&type=script&setup=true&lang=js"

import "./FooterBars.vue?vue&type=style&index=0&id=52ff73e0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52ff73e0"]])

export default __exports__